import Toast from 'bootstrap.toast';
import { onModuleLoad } from 'runtime';
import { displayValidationSummary, hideValidationSummary } from 'ui-utils';
import { fetch } from 'utils';

onModuleLoad(import.meta, () => {
    const cart = document.getElementById('cart-summary');

    cart.addEventListener('applyDiscount', async e => {
        const container = document.getElementById('apply-discount');
        const response = await fetch(`/api/cart/apply-discount?code=${e.detail ? encodeURIComponent(e.detail) : ''}&deliveryAddressCountryCode=${cart.$data.deliveryAddress?.countryCode ? encodeURIComponent(cart.$data.deliveryAddress.countryCode) : ''}&deliveryAddressPostcode=${cart.$data.deliveryAddress?.postcode ? encodeURIComponent(cart.$data.deliveryAddress.postcode) : ''}`, {
            method: 'POST'
        });

        if (response.ok) {
            handleResponse(response);
            hideValidationSummary(container);
            Toast.getOrCreateInstance(container.querySelector('.success')).show();
        } else
            displayValidationSummary(container, [await response.text()]);
    });

    cart.addEventListener('removeDiscount', async e => {
        await handleResponse(await fetch(`/api/cart/remove-discount?code=${encodeURIComponent(e.detail)}&deliveryAddressCountryCode=${cart.$data.deliveryAddress?.countryCode ? encodeURIComponent(cart.$data.deliveryAddress.countryCode) : ''}&deliveryAddressPostcode=${cart.$data.deliveryAddress?.postcode ? encodeURIComponent(cart.$data.deliveryAddress.postcode) : ''}`, {
            method: 'DELETE'
        }));
    });

    cart.addEventListener('setDeliveryAddress', async () => {
        await handleResponse(await fetch(`/api/cart/set-delivery-address?deliveryAddressCountryCode=${cart.$data.deliveryAddress?.countryCode ? encodeURIComponent(cart.$data.deliveryAddress.countryCode) : ''}&deliveryAddressPostcode=${cart.$data.deliveryAddress?.postcode ? encodeURIComponent(cart.$data.deliveryAddress.postcode) : ''}`, {
            method: 'POST'
        }));
    });

    cart.addEventListener('setDeliveryMethod', async e => {
        // Set whether the delivery address is required for the delivery method. This makes sure when saying `cart.$data.deliveryAddress` it respects the current selected delivery method.
        cart.$data.cart.isDeliveryAddressRequired = e.detail.isAddressRequired;

        await handleResponse(await fetch(`/api/cart/set-delivery-method?id=${e.detail.id}&deliveryAddressCountryCode=${cart.$data.deliveryAddress?.countryCode ? encodeURIComponent(cart.$data.deliveryAddress.countryCode) : ''}&deliveryAddressPostcode=${cart.$data.deliveryAddress?.postcode ? encodeURIComponent(cart.$data.deliveryAddress.postcode) : ''}`, {
            method: 'POST'
        }));
    });

    async function handleResponse(response) {
        if (!response.ok)
            return;

        const data = await response.json();
        cart.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: data }));
    }
});